/**
 * Composant pour afficher une carte de statistiques
 * @module admin/components/StatCard
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant de carte de statistiques
 * @param {Object} props
 * @param {string} props.title - Titre de la carte
 * @param {React.ReactNode} props.children - Contenu de la carte
 * @param {string} [props.className] - Classes CSS supplémentaires
 * @returns {JSX.Element}
 */
const StatCard = ({ title, children, className = '' }) => {
  return (
    <div className={`admin-stat-card ${className}`}>
      {title && <h4>{title}</h4>}
      {children}
    </div>
  );
};

StatCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default StatCard;
